export default __webpack_public_path__ + "static/media/navigate-list-2.13377336.png";